const OVERLAY_PREFIX = '@OVERLAY';

export const SHOW = `${OVERLAY_PREFIX}/SHOW` as const;
export const HIDE = `${OVERLAY_PREFIX}/HIDE` as const;

export const showOverlay = payload => ({ type: SHOW, payload });

export const hideOverlay = () => ({ type: HIDE });
